export const DOCUMENT_UNTRUSTED_HEADER = 'X-Document-Untrusted';
export const DOCUMENT_CLEANED_HEADER = 'X-Document-Cleaned';
export const DOCUMENT_SESSION_COUNT_HEADER = 'X-Document-Session-Count';
export const DOCUMENT_SESSION_LIMIT_HEADER = 'X-Document-Session-Limit';
